export const ACTION_BATCH_GET_USER_DATA = "core/ACTION_BATCH_GET_USER_DATA";
export const ACTION_BATCH_SET_FETCHER = "core/ACTION_BATCH_SET_FETCHER";
export const ACTION_BATCH_GET_ALL_NOTIFICATIONS = "core/ACTION_BATCH_GET_ALL_NOTIFICATIONS";
export const ACTION_BATCH_MARK_NOTIFICATION_AS_READ = "core/ACTION_BATCH_MARK_NOTIFICATION_AS_READ";

export const GETTER_BATCH_GET_USER_DATA = "core/GETTER_BATCH_GET_USER_DATA";
export const GETTER_BATCH_GET_FETCHER = "core/GETTER_BATCH_GET_FETCHER";
export const GETTER_BATCH_GET_ALL_NOTIFICATIONS = "core/GETTER_BATCH_GET_ALL_NOTIFICATIONS";

export const MUTATION_BATCH_SET_USER_DATA = "core/MUTATION_BATCH_CANDIDATE_SET_USER_DATA";
export const MUTATION_BATCH_SET_FETCHER = "core/MUTATION_BATCH_SET_FETCHER";
export const MUTATION_BATCH_SET_ALL_NOTIFICATIONS = "core/MUTATION_BATCH_SET_ALL_NOTIFICATIONS";
